import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React from 'react';
import {Z_INDEXES} from '../../../constants/layers';
import {useIsScrollingUp} from '../../../hooks/useIsScrollingUp/useIsScrollingUp';
import {
  SCROLL_TO_TOP_X_OFFSET_CSS_VARIABLE,
  SCROLL_TO_TOP_Y_OFFSET_CSS_VARIABLE,
} from '../../../hooks/useSetScrollToTopOffset/useSetScrollToTopOffset';
import {CircleButton} from '../../atoms/Buttons/CircleButton';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';

interface Props {
  position: 'left' | 'right';
}
export const ScrollToTop: React.FC<Props> = ({position}) => {
  const {t} = useTranslation();
  const isScrollingUp = useIsScrollingUp();

  return (
    <FixedWrapper data-is-visible={isScrollingUp} $position={position}>
      <StyledCircleButton
        backgroundColor={'secondary'}
        onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth'})}
        aria-label={t('Scroll to top')}
      >
        <StyledUpIcon asset={GenericIconName.ArrowLeft} size="XS" />
      </StyledCircleButton>
    </FixedWrapper>
  );
};

const FixedWrapper = styled.div<{$position: Props['position']}>`
  position: fixed;
  bottom: calc(16px + var(${SCROLL_TO_TOP_Y_OFFSET_CSS_VARIABLE}, 0px));
  z-index: ${Z_INDEXES.APP_SCROLL_TO_TOP};

  left: ${({$position}) =>
    $position === 'left'
      ? `var(${SCROLL_TO_TOP_X_OFFSET_CSS_VARIABLE}, 1rem)`
      : 'unset'};
  right: ${({$position}) =>
    $position === 'right'
      ? `var(${SCROLL_TO_TOP_X_OFFSET_CSS_VARIABLE}, 1rem)`
      : 'unset'};

  transform: translateX(0);
  opacity: 1;
  &[data-is-visible='false'] {
    transform: translateX(
      ${props => (props.$position === 'left' ? '-100px' : '100px')}
    );
    opacity: 0;
  }
  transition: transform 300ms linear, opacity 300ms linear;
`;

const StyledUpIcon = styled(Icon)`
  transform: rotate(90deg);
`;

const StyledCircleButton = styled(CircleButton)`
  box-shadow: 0 10px 15px 0 rgb(0 0 0 / 8%), 0 2px 2px 0 rgb(0 0 0 / 5%);
  width: 48px;
  height: 48px;
  opacity: 0.9;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
